const LOGGLY_ENABLED = false;
const LOGGLY_TOKEN = "06f405f0-76f6-4929-b1e8-32bfe1f4ad66";

export async function sendToLoggly(obj: object) {
	if (LOGGLY_ENABLED)
		return await fetch(
			`https://logs-01.loggly.com/inputs/${LOGGLY_TOKEN}/tag/http/`,
			{
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(obj),
			},
		);
}

if (LOGGLY_ENABLED && typeof window === "undefined" && process.on) {
	const oldConsole = {
		log: console.log,
		warn: console.warn,
		error: console.error,
	};

	process.on("uncaughtException", (err) => {
		console.error(err);
	});

	process.on("unhandledRejection", (reason) => {
		console.error(reason);
	});

	const logAndLoggly =
		(type: keyof typeof oldConsole) =>
		(...args: Array<unknown>) => {
			oldConsole[type](...args);
			sendToLoggly(args);
		};

	console.log = logAndLoggly("log");
	console.warn = logAndLoggly("warn");
	console.error = logAndLoggly("error");
}
